module.exports = __webpack_public_path__ + "static/fika-logo-e41f9387f0d870c79ce9f14d438d62af.png";